import { gsap } from 'gsap'
export default {
  init() {
    console.log('contatti');


    const buttons = document.querySelectorAll('.change-select');

    buttons.forEach((button) => {
      button.addEventListener('click', function() {
        // Prima rimuovo la classe da tutti i bottoni
        buttons.forEach(btn => {
          const element = btn.querySelector('.font-Sometimes-Times-Italic');
          if (element) {
            element.classList.remove('activeBtn');
          }
        });
        
        // Poi aggiungo la classe solo al bottone cliccato
        const clickedElement = button.querySelector('.font-Sometimes-Times-Italic');
        if (clickedElement) {
          clickedElement.classList.add('activeBtn');
        }
    
        // Gestisco la visibilità dei form
        const target = this.dataset.value;
        
        // Prima nascondo tutti i form rimuovendo la classe 'active'
        const allForms = document.querySelectorAll('.form');
        allForms.forEach(form => {
          console.log("ciao")
          form.classList.remove('activeForm');
        });
        
        // Poi mostro solo il form corrispondente al bottone cliccato
        const formToShow = allForms[target - 1]; // -1 perché i form partono da 0
        if (formToShow) {
          formToShow.classList.add('activeForm');

          // Faccio lo scroll verso il form attivato con offset
          setTimeout(() => {
            // Calcolo la posizione del form
            const formRect = formToShow.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // Calcolo la posizione desiderata con un offset di 50px per evitare il taglio
            const scrollToY = formRect.top + scrollTop - 200;
            
            // Eseguo lo scroll
            window.scrollTo({
              top: scrollToY,
              behavior: 'smooth'
            });
          }, 100);

        }

      });
    });



  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};